import { defineMessages } from 'react-intl';

const scope = 'labels';

export default defineMessages({
  getSupport: {
    id: `${scope}.need_help`,
    defaultMessage: 'Need help?',
  },
  hide: {
    id: `${scope}.hide`,
    defaultMessage: 'Hide',
  },
  dbbuk: {
    id: `${scope}.chat_with_us`,
    defaultMessage: 'Chat with us',
  },
  newMessage: {
    id: `${scope}.new_message`,
    defaultMessage: 'New message',
  },
  hideAriaLabel: {
    id: `${scope}.hide_aria_label`,
    defaultMessage: 'Hide chat assistant',
  },
});
